import React, { Component } from 'react';

class ModalImage extends Component {
  constructor(props) {
    super(props);
    this.modalContentRef = React.createRef();
    this.state = {
      isModalOpen: false,
      showScrollForMore: false,
      hasScrolled: false,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.checkScrollableContent);
  }

  componentDidUpdate(prevProps, prevState) {
    const { isModalOpen } = this.state;
    if (isModalOpen && !prevState.isModalOpen) {
      this.checkScrollableContent();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkScrollableContent);
  }

  checkScrollableContent = () => {
    const { current } = this.modalContentRef;
    if (current) {
      const { scrollHeight, clientHeight } = current;
      const showScrollForMore = scrollHeight > clientHeight;
      this.setState({ showScrollForMore });
    }
  };

  handleScroll = () => {
    this.setState({ hasScrolled: true });
  };

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false, hasScrolled: false });
  };

  handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) this.setState({ isModalOpen: false, hasScrolled: false });
  };

  render() {
    const { isModalOpen, showScrollForMore, hasScrolled } = this.state;
    const { title = '', description = '', children } = this.props;

    const modifiedChildren = React.Children.map(children, (child) => {
      if (child.type === 'img') {
        // Remove existing height property and set width to 100%
        return React.cloneElement(child, { style: { height: 'unset', width: '100%' } });
      }
      return child;
    });

    return (
      <div style={{ all: 'unset' }}>
        <div style={{ all: 'unset' }} onClick={this.openModal}>{children}</div>
        {isModalOpen && (
          <div className="modal-overlay" onClick={this.handleOverlayClick}>
            <div className="modal-content modal-styling" ref={this.modalContentRef} onScroll={this.handleScroll}>
              <button onClick={this.closeModal}>Close</button>
              {title}
              {modifiedChildren}
              <p className="modal-description">{description}</p>
              {showScrollForMore && !hasScrolled && ( <div className="scroll-for-more">Scroll for more</div>)}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ModalImage;